import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import sprite from '../../../../img/sprites.svg';

import { openToggle, toggle } from '../../../../utils/accordion';

import TrialProgramsCard from '../ProgramsCard/TrialProgramsCard';
import TrialProgramsTable from '../ProgramsTable/TrialProgramsTable';

const TrialProgramsBlock = ({ title, courses, initiallyOpen }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (courses.length > 0) {
      const blocks = document.querySelectorAll('.page-block.open[data-block="toggle"]');
      blocks.forEach(block => {
        openToggle(block);
      });
    }
  }, [courses]);

  const handleToggle = (target) => {
    const btn = target.closest('[data-top="toggle"]');
    const block = target.closest('[data-block="toggle"]');

    if (btn && block) {
      toggle(block);
    }
  };

  const getAccounts = (product_id, typeCur) => {
    navigate('/finance/accounts');
    localStorage.setItem('product_id', JSON.stringify(product_id));
    localStorage.setItem('type', JSON.stringify(typeCur));
  };

  return (
    <div
      className={`page-block ${initiallyOpen ? 'open' : ''}`}
      data-block="toggle"
    >
      <button
        type="button"
        className="page-block-head"
        data-top="toggle"
        onClick={(e) => handleToggle(e.target)}
      >
        <h3 className="page-block-head__title">{title}</h3>
        <svg className="icon">
          <use href={`${sprite}#arrow`}></use>
        </svg>
      </button>

      <div className="page-block__content" data-content="toggle">
        <div className="page__cards cards">
          {courses.length > 0 &&
            courses.map(course => (
              <TrialProgramsCard
                key={course.id}
                course={course}
                getAccounts={getAccounts}
              />
            ))
          }
        </div>

        <div className="page__table table">
          {courses.length > 0 && (
            <TrialProgramsTable
              courses={courses}
              getAccounts={getAccounts}
            />
          )}
        </div>
      </div>
    </div>
  );
};

TrialProgramsBlock.propTypes = {
  courses: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  initiallyOpen: PropTypes.bool,
};

TrialProgramsBlock.defaultProps = {
  initiallyOpen: true,
};

export default TrialProgramsBlock;